import { resolveResponsiveProp } from './responsiveProp';
export const resolveSpacing = (value) => {
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value.custom === 'string') {
        return value.custom;
    }
    return `${value.custom}px`;
};
export const margin = (props) => {
    const { $m, $mx, $my, $ml, $mr, $mt, $mb } = props;
    return `
    ${$m
        ? resolveResponsiveProp($m, (value) => `margin: ${resolveSpacing(value)};`)
        : ''}
    ${$mx
        ? resolveResponsiveProp($mx, (value) => `
        margin-left: ${resolveSpacing(value)};
        margin-right: ${resolveSpacing(value)};
      `)
        : ''}
    ${$my
        ? resolveResponsiveProp($my, (value) => `
        margin-top: ${resolveSpacing(value)};
        margin-bottom: ${resolveSpacing(value)};
      `)
        : ''}
    ${$ml
        ? resolveResponsiveProp($ml, (value) => `margin-left: ${resolveSpacing(value)};`)
        : ''}
    ${$mr
        ? resolveResponsiveProp($mr, (value) => `margin-right: ${resolveSpacing(value)};`)
        : ''}
    ${$mt
        ? resolveResponsiveProp($mt, (value) => `margin-top: ${resolveSpacing(value)};`)
        : ''}
    ${$mb
        ? resolveResponsiveProp($mb, (value) => `margin-bottom: ${resolveSpacing(value)};`)
        : ''}
  `;
};
export const padding = (props) => {
    const { $p, $px, $py, $pl, $pr, $pt, $pb } = props;
    return `
    ${$p
        ? resolveResponsiveProp($p, (value) => `padding: ${resolveSpacing(value)};`)
        : ''}
    ${$px
        ? resolveResponsiveProp($px, (value) => `
        padding-left: ${resolveSpacing(value)};
        padding-right: ${resolveSpacing(value)};
      `)
        : ''}
    ${$py
        ? resolveResponsiveProp($py, (value) => `
        padding-top: ${resolveSpacing(value)};
        padding-bottom: ${resolveSpacing(value)};
      `)
        : ''}
    ${$pl
        ? resolveResponsiveProp($pl, (value) => `padding-left: ${resolveSpacing(value)};`)
        : ''}
    ${$pr
        ? resolveResponsiveProp($pr, (value) => `padding-right: ${resolveSpacing(value)};`)
        : ''}
    ${$pt
        ? resolveResponsiveProp($pt, (value) => `padding-top: ${resolveSpacing(value)};`)
        : ''}
    ${$pb
        ? resolveResponsiveProp($pb, (value) => `padding-bottom: ${resolveSpacing(value)};`)
        : ''}
  `;
};
//# sourceMappingURL=space.js.map